module.exports = __webpack_public_path__ + "img/mail_logo.6675fac0.svg";